import { FormattedMessage } from 'react-intl';

export type BulkStatusError<TErrorCode extends string = string> = {
    readonly errorCode: TErrorCode;
    readonly identifiers: readonly string[];
    readonly identifierType: 'VEHICLE' | 'ORDER';
};

type BulkStatusErrorMessageProps<TErrorCode extends string> = {
    readonly errors: readonly BulkStatusError<TErrorCode>[];
    readonly getErrorMessageId: (errorCode: TErrorCode) => string;
};

const getTranslationSource = (identifierType: 'VEHICLE' | 'ORDER') =>
    identifierType === 'VEHICLE'
        ? 'outboundOrderBook.compoundManagement.bulkStatusUpdate.unableToAddVehicles'
        : 'outboundOrderBook.transportAssignments.bulkUpdate.unableToUpdateAssignment';

export const getDefaultBulkStatusErrorMessageId = (errorCode: string) =>
    `outboundOrderBook.bulkStatusUpdate.error.${errorCode}`;

export const BulkStatusErrorMessage = <TErrorCode extends string>({
    errors,
    getErrorMessageId,
}: BulkStatusErrorMessageProps<TErrorCode>) => (
    <div className="alert alert-danger width-100pct space-y-10">
        {errors.map((error) => (
            <div className="display-flex gap-10" key={`${error.identifiers[0]} ${error.errorCode}`}>
                <span className="text-color-danger text-size-h4 rioglyph rioglyph rioglyph-error-sign" />
                <div>
                    <strong className="text-size-16">
                        <FormattedMessage
                            id={getTranslationSource(error.identifierType)}
                            values={{ count: error.identifiers.length }}
                        />{' '}
                        <FormattedMessage id="outboundOrderBook.bulkStatusUpdate.error.reason" />{' '}
                        <FormattedMessage id={getErrorMessageId(error.errorCode)} />
                    </strong>{' '}
                    <FormattedMessage id="outboundOrderBook.bulkStatusUpdate.error.automaticallyExcluded" />{' '}
                    {error.identifiers.join(', ')}
                </div>
            </div>
        ))}
    </div>
);
